import React from "react";
import { Modal } from "react-bootstrap";
import styled from "styled-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";

const PreviewContainer = styled.table`
  width: 100% !important;
  border-collapse: collapse !important;
  margin: 1rem 0 !important;
  table-layout: auto !important;
  padding: 1rem;
  max-height: 70vh;
  overflow-y: auto;
  font-family:
    "Pretendard",
    -apple-system,
    sans-serif;
  line-height: 1.6;
  color: #334155;

  table {
    width: 100% !important;
    border-collapse: collapse !important;
  }
  th,
  td {
    border: 1px solid #cbd5e1 !important;
    padding: 10px;
  }
  h1,
  h2,
  h3 {
    margin: 1.5rem 0 1rem 0;
    font-weight: 700;
    display: block;
  }
  p {
    margin-bottom: 1rem;
    display: block;
  }
  ul,
  ol {
    padding-left: 1.5rem;
    margin-bottom: 1rem;
    display: block;
  }
`;

const ModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1.25rem 1.5rem;
  border-bottom: 1px solid #e2e8f0;

  h5 {
    margin: 0;
    font-weight: 800;
    color: #0f172a;
  }

  .close-btn {
    background: none;
    border: none;
    color: #94a3b8;
    font-size: 1.2rem;
    cursor: pointer;
    &:hover {
      color: #475569;
    }
  }
`;

interface PreviewModalProps {
  show: boolean;
  onHide: () => void;
  title: string;
  content: string;
}

const TermTemplatesPreviewModal = ({
  show,
  onHide,
  title,
  content,
}: PreviewModalProps) => {
  return (
    <Modal show={show} onHide={onHide} size="lg" centered scrollable>
      <ModalHeader>
        <h5>약관 미리보기 : (제목) {title}</h5>
        <button className="close-btn" onClick={onHide}>
          <FontAwesomeIcon icon={faTimes} />
        </button>
      </ModalHeader>
      <Modal.Body>
        <PreviewContainer dangerouslySetInnerHTML={{ __html: content }} />
      </Modal.Body>
    </Modal>
  );
};

export default TermTemplatesPreviewModal;
